module.exports = __webpack_public_path__ + "img/prospect3.b22d70cb.jpg";